const isForwardNavigationBlockedByInvalidStep = ({
    steps,
    targetStepId,
    blockForwardOnInvalidSteps = false,
}) => {
    if (!blockForwardOnInvalidSteps) {
        return false
    }

    const activeStepIndex = steps.findIndex(step => step.isOpen)
    const targetStepIndex = steps.findIndex(step => step.id === targetStepId)

    if (
        activeStepIndex < 0
        || targetStepIndex < 0
        || targetStepIndex <= activeStepIndex
    ) {
        return false
    }

    return steps.slice(0, targetStepIndex).some(step => (
        step.isVisible
        && !step.isDisabled
        && step.hasValidationResult
        && !step.isValid
    ))
}

export { isForwardNavigationBlockedByInvalidStep }
export default isForwardNavigationBlockedByInvalidStep
